import { Action, createReducer, on } from '@ngrx/store';
import { fetchSupportTicketsList, fetchSupportTicketsListSuccess, fetchSupportTicketsListFailure, fetchSupportTicketsDetail, fetchSupportTicketsDetailSuccess, fetchSupportTicketsDetailFailure, ticketCards, ticketCardsFailure, ticketCardsSuccess, fetchSupportTicketsReplays, fetchSupportTicketsReplaysFailure, fetchSupportTicketsReplaysSuccess } from './support-tickets.actions';

export interface SupportTicketsState {
  list: any[];
  detail:any;
  cards:any[];
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: SupportTicketsState = {
  list: [],
  detail: null,
  cards: [],
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const SupportTicketsReducer = createReducer(
  initialState,
  on(fetchSupportTicketsList, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchSupportTicketsListSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchSupportTicketsListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),

  on(fetchSupportTicketsDetail, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchSupportTicketsDetailSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      detail: response.result
    };
  }),
  on(fetchSupportTicketsDetailFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),

  on(ticketCards, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(ticketCardsSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      cards: response
    };
  }),
  on(ticketCardsFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),

  on(fetchSupportTicketsReplays, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchSupportTicketsReplaysSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
    };
  }),
  on(fetchSupportTicketsReplaysFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),
);

// Selector
export function reducer(state: SupportTicketsState | undefined, action: Action) {
  return SupportTicketsReducer(state, action);
}
